import React from 'react'
import { Row } from 'react-bootstrap'
import Box from '../box'
import Spinner from '../../common/spinner-container'
import useUserInterests from '../../../hooks/use-user-interests'

const interests = [
    {},
    {},
    {},
    {}
]

const isBusy = false

const InterestsList = ({
    editable,
    userId,
    onDelete = () => {},
    variant = 'primary'
}) => {

    const { userInterests, isBusy } = useUserInterests({ userId })

    if (isBusy) {
        return (<Spinner />)
    }

    if (!userInterests.length) {
        return (<div className='text-center text-muted'>There are no interests</div>)
    }

    const renderInterest = (userInterest, key) => {
        return (
            <Box variant={variant} key={key} userInterest={userInterest} />
        )
    }

    return (
        <Row>
            {userInterests.map(renderInterest)}
        </Row>
    )
}

export default InterestsList